export default __webpack_public_path__ + "static/media/224.5200fac8.gif";